import { IThread } from '~/client/graph'
import BaseModel from '~/client/src/shared/models/BaseModel'

export default class Thread extends BaseModel<IThread> {}
